<template>
  <div class="right-menu">
    <el-dropdown v-if="isLogin" class="avatar-container right-menu-item hover-effect" trigger="click">
      <div class="avatar-wrapper">
        <span v-if="!isMobile" style="float: left;font-size: 15px; padding-top: 10px;">尊敬的***{{ userInfo.slice(-4) }}用户您好！</span> 
        <img src="@/assets/img/HLlogo2.jpg" class="user-avatar"/>
        <i class="el-icon-caret-bottom" />
      </div>
      <el-dropdown-menu>
        <router-link to="/my-order" style="text-decoration: none;">
          <el-dropdown-item>我的订单</el-dropdown-item>
        </router-link>
        <el-dropdown-item divided @click.native="logout()">
          <span style="display: block;">退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div v-else class="avatar-container right-menu-item hover-effect">
      <div class="avatar-wrapper">
        <router-link to="/login">
          <el-avatar class="user-avatar">登录</el-avatar>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed:{
    ...mapGetters([
      'userInfo',
      'isMobile',
      'isLogin',
    ])

  },
  methods:{
    logout() {
      this.$confirm("确定要退出系统吗？","提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        sessionStorage.clear();
        this.$store.dispatch('user/logout')
        this.$router.push('/login')
      }).catch(() => {
        return false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.right-menu {
  float: right;
  height: 100%;
  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;
    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0,0,0,0.025);
      }
    }
  }
  .avatar-container {
    margin-right: 30px;
    .avatar-wrapper {
      margin-top: 5px;
      position: relative; 
      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/layout/components/NavBar/RightMenu.vue